import { type FC, type ReactNode, useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

/**
 * Renders children into an open shadow root on a wrapper div, isolating the email's CSS from the app's.
 * Replaces `react-shadow`'s `root.div`, whose `react-dom/server` import every `@qw/ui` consumer would load.
 */
export const ShadowHost: FC<{ className?: string; children?: ReactNode }> = ({ className, children }) => {
  const hostRef = useRef<HTMLDivElement>(null);
  const [shadowRoot, setShadowRoot] = useState<ShadowRoot | null>(null);

  useLayoutEffect(() => {
    const host = hostRef.current;
    if (host) {
      setShadowRoot(host.shadowRoot ?? host.attachShadow({ mode: "open" }));
    }
  }, []);

  return (
    <div ref={hostRef} className={className}>
      {shadowRoot && createPortal(children, shadowRoot)}
    </div>
  );
};
